<template>
    <base-file-input
        v-model="model"
        v-validate="{
            required: true,
        }"
        input-id="consent-form"
        :required="true"
        :field="field"
        input-label="SIGNED CONSENT FORM"
        :placeholder="
            originalFileName || 'Select scan copy (JPG, PNG or PDF file)'
        "
        drop-placeholder="Drop file here..."
        file-type="consentForm"
        accept="image/*,application/pdf"
        data-vv-name="Signed Consent Form"
        :class="{
            'is-invalid': errors.has('Signed Consent Form'),
        }"
        @update:originalFileName="updateOriginalFileName"
    ></base-file-input>
</template>

<script>
import IdentityDocument from './IdentityDocument'
export default {
    // End of Component > inject

    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {},
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    extends: IdentityDocument, // End of Component > extends

    /*
    |--------------------------------------------------------------------------
    | Component > inject
    |--------------------------------------------------------------------------
    */
    inject: {}, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        field: {
            type: Object,
            default() {
                return {
                    isRequired: true,
                    isLocked: true,
                    key: 'documentInfo.consentForm.fileName',
                    originalFileNameKey:
                        'documentInfo.consentForm.originalFileName',
                }
            },
            required: false,
        },
        profileType: {
            type: String,
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {}
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    // computed: {
    //     isRequiredByprofileType() {
    //         if (this.profileType != 'Non-resident (tourist)') {
    //             this.field.isRequired = true
    //             return this.field.isRequired
    //         } else {
    //             this.field.isRequired = false
    //             return this.field.isRequired
    //         }
    //     },
    // }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {}, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {}, // End of Component > mounted
}
</script>

